import React from "react"


const features = [
  {
    id: 1,
    gifUrl:"/images/gif/projects.png",
    gifAlt:"Find social impact jobs",
    slide: "1/4",
    title: "自分にとって有意義なSDGジョブに出会う",
    subtitle: `ソーシャスは、機械学習を利用して、社会貢献への想いとキャリアゴールを両立できる機会をマッチングさせます。私たちは、社会貢献を真に充実したものにします。`,
    link:"AIマッチングについて詳しく見る",
    linkUrl:"https://www.notion.so/socious/Socious-Whitepaper-58fbe2c106f547898df42e409a00c73e#709f02a983e143b1b1b0520eab7a6f47"


  },
  {
    id: 2,
    gifUrl:"/images/gif/hired.png",
    gifAlt:"Safely get hired and paid",
    slide: "2/4",
    title: "安全に仕事と報酬を得る",
    subtitle: `ブロックチェーン技術を活用し、安全な取引と業界最安手数料を実現. プラットフォームは非常にシンプルに設計されており、通常経験するような面倒な手続きなしで、求人に応募し、採用され、報酬を得ることができます`,
    link:"社会によいブロックチェーンについて詳しく見る",
    linkUrl:"https://www.notion.so/socious/Socious-Whitepaper-58fbe2c106f547898df42e409a00c73e#15ab48512ddb46fbb7d01cfc8472c693",
  },
  {
    id: 3,
    gifUrl:"/images/gif/impact.png",
    gifAlt:"See your impact grow",
    slide: "3/4",
    title: "あなたのインパクトの成長を見る",
    subtitle: `SDGプロジェクトに貢献するたびに、あなたのインパクトスコアは伸びていきます。次々と貢献することで、自分のインパクトが蓄積され、目的志向のプロフェッショナルとして評価されるようになります。`,
    link:"インパクトスコアについて詳しく見る",
    linkUrl:"https://www.notion.so/socious/Socious-Whitepaper-58fbe2c106f547898df42e409a00c73e#27759763f0d941788af336561a40d8d7"

  },
  {
    id: 4,
    gifUrl:"/images/gif/payment.png",
    gifAlt:"Earn tokens",
    slide: "4/4",
    title: "トークンを獲得する",
    subtitle: `あなたがインパクト団体のために働いたり、ボランティアをするたびに、ソーシャス上で様々商品・サービスと交換したり寄付に使えるソーシャルグッドな暗号資産であるTHANKトークンが報酬として与えられます。`,
    link:"THANKについて詳しく見る",
    linkUrl:"https://www.notion.so/socious/Socious-Whitepaper-58fbe2c106f547898df42e409a00c73e#b78ae33e7f814ffea0e9030d2775db8f"

  }

]

export default features
